import React, { useState } from "react";

export const OTHER_LABEL = "أخرى";
const OTHER_VALUE = "__other__";

const SelectWithOther = ({ value, onChange, options, className, testid, placeholder }) => {
  const [isOther, setIsOther] = useState(() => options.length === 0 || (!!value && !options.includes(value)));  // no presets → custom text directly

  const onSelect = (e) => {
    if (e.target.value === OTHER_VALUE) {
      setIsOther(true);
      onChange(options.includes(value) ? "" : value);
    } else {
      setIsOther(false);
      onChange(e.target.value);
    }
  };

  return (
    <div className="space-y-2">
      <select className={className} value={isOther ? OTHER_VALUE : value} onChange={onSelect} data-testid={testid}>
        {options.map((c) => <option key={c} value={c}>{c}</option>)}
        <option value={OTHER_VALUE}>{OTHER_LABEL}</option>
      </select>
      {isOther && (
        <input
          className={className}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          required
          maxLength={60}
          data-testid={`${testid}-other-input`}
        />
      )}
    </div>
  );
};

export default SelectWithOther;
